/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@jira/software__capacity/src/__generated__/CapacityPeopleViewContentQuery$parameters.ts';
import type { Queries } from './Queries.types.tsx';

type CapacityEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	{},
	{
		tenantContext: TenantContext;
	}
>;

export const capacityEntryPoint: EntryPoint<CapacityEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<CapacityEntryPointComponent>(
			/* webpackChunkName: "async-jira-capacity-people" */ './CapacityEntryPoint.tsx',
		),
		getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
			const {
				context: { match },
				tenantContext,
			} = entryPointRouteParams;

			const boardId = match.params.boardId ?? '';
			const sourceAri = `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`;

			return {
				queries: {
					capacityData: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters,
						variables: {
							cloudId: tenantContext.cloudId,
							id: sourceAri,
						},
					},
				},
				entryPoints: {},
				extraProps: {
					tenantContext,
					sourceAri,
				},
			};
		},
	});
